import { useLazyQuery } from '@apollo/client'
import {
  GET_CACHE_EDIT_PAGE_DETAILS,
  GetCacheEditPageDetailsResponse,
} from 'queries/get-cache-edit-page-details'

export const useGetCacheEditPageDetails = () => {
  const [getCacheEditPageDetails, { data, loading, error }] =
    useLazyQuery<GetCacheEditPageDetailsResponse>(GET_CACHE_EDIT_PAGE_DETAILS, {
      fetchPolicy: 'network-only',
    })

  return {
    getCacheEditPageDetails,
    data: data?.cacheEditPageDetails,
    loading,
    error,
  }
}
